<!-- Courses -->
<section *ngIf="!course">
  <!-- Page Title -->
  <div class="title">
      <h1>Quiz Questions</h1>
  </div>

  <hr class="line" *ngIf="courses.length > 0">

  <!-- List of Courses -->
  <div class="courses-list" *ngIf="!courseID">
      <h4 class="select course">Select Course:</h4>

      <!-- Individual Courses -->
      <div *ngFor="let course of courses" class="content-box course selectable" (click)="onCourse(course)">
        <h1>{{courseName(course)}}</h1>
      </div>
  </div>
</section>


<!-- Course Modules -->
<section *ngIf="course && !module">
  <!-- Page Title -->
  <div class="title">
      <h1>Quiz Questions</h1>
      <ul class="breadcrumbs">
        <li><a [routerLink]="" (click)="open('', '')">All</a></li>
        <li>{{courseName(course)}} Modules</li>
      </ul>
  </div>

  <hr class="line" *ngIf="courses.length > 0">

  <!-- List of Modules -->
  <div class="courses-list modules">
      <h4 class="select course module">Select Module:</h4>

      <!-- Individual Modules -->
      <div *ngFor="let module of course?.modules" class="content-box course module selectable" (click)="onCourseModule(module)">
        <h1>{{module.moduleNumber}}. {{module.title}}</h1>
      </div>
  </div>
</section>


<!-- Quiz Questions -->
<section *ngIf="course && module">
  <!-- Page Title -->
  <div class="title">
    <h1>Quiz Questions</h1>
    <ul class="breadcrumbs">
      <li><a [routerLink]="" (click)="open('', '')">All</a></li>
      <li><a [routerLink]="" (click)="open(courseID, '')">{{courseName(course)}} Modules</a></li>
      <li>{{module.moduleNumber}}. {{module.title}}</li>
    </ul>
  </div>

  <div class="card">
      <article class="table-header">

        <!-- Toolbar -->
        <div class="toolbar">
            <!-- Add Question -->
            <button type="button" class="dt-button" (click)="addQuestion()">
              <span>Add Question</span>
              <mdb-icon class="text-success ml-1" fas icon="plus" size="md"></mdb-icon>
            </button>
          </div>
      </article>

      <div class="card-body" style="overflow-x:auto;">
          <!-- Table -->
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table-striped stripe hover row-border order-column">
              <!-- Head -->
              <thead>
                  <tr>
                      <th>#</th>
                      <th class="th-question">Question</th>
                      <th class="th-answers">Answers</th>
                      <th class="th-hint">Hint</th>
                      <th>Actions</th>
                  </tr>
              </thead>

              <!-- Body -->
              <tbody>
                  <tr *ngFor="let q of questions; index as qi">
                      <td>{{qi + 1}}.</td>
                      <td>{{q.question}}</td>
                      <td>
                        <div *ngFor="let answer of q.answers; index as ai" [ngClass]="{ 'text-success': ai === q.correctAnswerIndex }">
                          {{letterArray[ai]}}. {{answer}}
                        </div>
                      </td>
                      <td>{{q.hint}}</td>
                      <td class="td-actions">
                        <button (click)="editQuestion(qi)"><mdb-icon fas icon="pen"></mdb-icon></button>
                        <button (click)="deleteQuestion(qi)" class="ml-2 btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</section>
